import React, { Component } from 'react';
//import { render } from 'react-dom';
//import Hello from './Hello';
import './style.css';
import '../assets/css/formulario.css'
import Swal from 'sweetalert2';
import Loading from "react-fullscreen-loading";
import ReCAPTCHA from 'react-google-recaptcha';
import iconEnvioDoc from "../assets/imgs/envioDOCUMENTO-rev.png";
import { TratamientoDatosCibbString } from './TerminosCondicionesCibb.js';

export class Formulario extends Component {
    constructor(props) {
        super(props);

        var idcongreso = -1;
        var aceptaRegistro = true;

        this.state =
        {
            recaptchaToken: null,
            evento: idcongreso,
            titulo: "",
            shortitulo: "",
            isDespuesRegInicio: aceptaRegistro,
            fechaInicioInsc: "",
            fechaFinInsc: "",
            isAntesRegFin: aceptaRegistro,
            anioEvento: "",
            isRegistrado: false,
            onProcess: false,
            datosFormulario: {
                nombres: "",
                apellidos: "",
                tipoIdentificacion: "",
                numeroIdentificacion: "",
                paises: [], //json completo de paises y ciudades
                paisId: "", //guarda id de pais
                paisNom: "",
                ciudades: [], //json completo de ciudades segun pais seleccionado
                ciudadId: "", //guarda id de ciudad
                ciudadNom: "",
                tipoInstitucion: "",
                tipoInstitucionDet: "",
                nombreInstitucion: "",
                tipoParticipante: "",
                tipoParticipanteDet: "",
                tipoEstudiante: null,
                tipoEstudianteDet: "",
                email: "",
                celular: "",
                tipoParticipacion: "",
                tipoParticipacionDet: "",
                tipoAsistencia: "P",
                presentacion: "",
                modoInformado: "",
                modoInformadoDet: "",
                otroModoInformado: "",
                esEspol: "N",
                esEspolDet: "No",
                esPostgrado: "N",
                esPostgradoDet: "No",
                pagado: 1,
                idCongreso: idcongreso,
                anioCongreso: "2025",
                valorCIBB: 150.00,
                formaPago: "",
                comprobantePago: "",
                aceptaTerminos: false,
                aceptaAvisoTraDatos: false
            },
            isLoading: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.getDatosEspol = this.getDatosEspol.bind(this);
        this.getDatosBienestar = this.getDatosBienestar.bind(this);
        this.getCiudades = this.getCiudades.bind(this);
        this.setNomPais = this.setNomPais.bind(this);
        this.setPaisCedula = this.setPaisCedula.bind(this);
        this.setNomCiudad = this.setNomCiudad.bind(this);
        this.setCibbValor = this.setCibbValor.bind(this);
        this.esGraduadoPregrado = this.esGraduadoPregrado.bind(this);
        this.esGraduadoPostgrado = this.esGraduadoPostgrado.bind(this);
        this.esEstudiantePostgrado = this.esEstudiantePostgrado.bind(this);
        this.setModoInformadoDet = this.setModoInformadoDet.bind(this);
        this.setTipoInstitucionDet = this.setTipoInstitucionDet.bind(this);
        this.setTipoParticipanteDet = this.setTipoParticipanteDet.bind(this);
        this.setTipoEstudianteDet = this.setTipoEstudianteDet.bind(this);
        this.setTipoParticipacionDet = this.setTipoParticipacionDet.bind(this);
        this.setEsEspolDet = this.setEsEspolDet.bind(this);
        this.setEsPostgradoDet = this.setEsPostgradoDet.bind(this);
        this.getCelularFromWsAlumni = this.getCelularFromWsAlumni.bind(this);
        this.handleRecaptchaChange = this.handleRecaptchaChange.bind(this);
        this.formatDateString = this.formatDateString.bind(this);
        this.showTermsTratamiento = this.showTermsTratamiento.bind(this);
    }

    handleRecaptchaChange(token) {
        this.setState({
            recaptchaToken: token
        })
    };

    expresiones = {
        cedula: /^\d{10}$/, //10 numeros
        usuario: /^[a-zA-Z0-9_-]{5,14}$/, // Letras, numeros, guion y guion_bajo
        pasaporte: /^[a-zA-Z0-9_.-]{5,20}$/, // Letras, numeros, guion, punto y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,50}$/, // Letras y espacios, pueden llevar acentos.
        //nombreinstitucion: /^.* $/,
        nombreinstitucion: /^[a-zA-ZÀ-ÿ\s]{1,255}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        correo: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        telefono: /^\d{0,14}$/ // 7 a 14 numeros.
    }


    getDatosEspol(ced) {
        //console.log("getDatosEspol", ced);
        //cargar formulario con datos de la API
        try {
            this.setState({ isLoading: true });
            fetch("https://wsalumni.espol.edu.ec/api/Informacion/GetIdPersona/" + ced)
                .then(response => response.json())
                .then(responsejson => {
                    this.setState({ isLoading: false });
                    //console.log(responsejson);                
                    var dto = this.state.datosFormulario;
                    var datosgrado = responsejson.data["tdatosalumni"];
                    if (datosgrado !== null) {
                        //console.log("Sí es de ESPOL");
                        dto["esEspol"] = "S";
                        dto["esEspolDet"] = "Sí";
                        dto["nombres"] = datosgrado.nombres;
                        dto["apellidos"] = datosgrado.apellidos;
                        dto["tipoInstitucion"] = "U";
                        dto["tipoInstitucionDet"] = "Universidad";
                        document.getElementById("universidad").checked = true;
                        dto["nombreInstitucion"] = "Escuela Superior Politécnica del Litoral";
                        dto["email"] = datosgrado.email;
                        //dto["celular"] = datosgrado.codarea + datosgrado.telefonocelular;
                        //chequear si es estudiante de pregrado
                        //console.log(datosgrado.nombrecarrera);
                        //console.log(datosgrado.fechagraduacion);
                        //console.log(datosgrado.nombrecarrera !== null);
                        //console.log(datosgrado.fechagraduacion === null);
                        if (datosgrado.nombrecarrera !== null && datosgrado.fechagraduacion === null) {

                            //console.log("entra a pregrado");

                            //console.log(datosgrado.nombrecarrera);
                            dto["tipoParticipante"] = "E";
                            dto["tipoParticipanteDet"] = "Estudiante";
                            document.getElementById("estudiante").checked = true;
                            dto["tipoEstudiante"] = "B";
                            dto["tipoEstudianteDet"] = "Pregrado";
                            document.getElementById("pregrado").checked = true;
                            document.getElementById("profesional").checked = false;
                        }
                        //chequear si es estudiante de postgrado
                        else {
                            if (this.esEstudiantePostgrado(ced)) {
                                //console.log("Sí es estudiante de postgrado");
                                dto["tipoParticipante"] = "E";
                                dto["tipoParticipanteDet"] = "Estudiante";
                                document.getElementById("estudiante").checked = true;
                                dto["tipoEstudiante"] = "A";
                                dto["tipoEstudianteDet"] = "Postgrado";
                                dto["esPostgrado"] = "S";
                                document.getElementById("postgrado").checked = true;
                                document.getElementById("profesional").checked = false;
                            }
                            //chequear si es graduado de pregrado o graduado de postgrado
                            else {
                                if ((datosgrado.nombrecarrera !== null && datosgrado.fechagraduacion !== null) || this.esGraduadoPostgrado(ced)) {
                                    //console.log(datosgrado.nombrecarrera);
                                    dto["tipoParticipante"] = "P";
                                    dto["tipoParticipanteDet"] = "Profesional";
                                    document.getElementById("profesional").checked = true;
                                    document.getElementById("estudiante").checked = false;
                                }
                            }
                        }

                        this.setState({ datosFormulario: dto });
                    }
                }).catch(error => {
                    console.log("Error: ", error);
                    this.setState({ isLoading: false });
                });
        }catch (error) { console.log("Error: ", error); };
    }

    getDatosBienestar(ced) {
        try {

            //fetch("https://wssaac.espol.edu.ec/bienestar/api/Informacion/GetEstudianteAcadByIdentificacion/" + ced)
            fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/GetDatosBienestarAPI/" + ced)
                .then(response => response.json())
                .then(responsejson => {
                    var dto = this.state.datosFormulario;
                    var datosbienestar = responsejson["data"];
                    if (datosbienestar !== null) {
                        dto["esEspol"] = "S";
                        dto["esEspolDet"] = "Sí";
                        dto["nombres"] = datosbienestar.nombres;
                        dto["apellidos"] = datosbienestar.apellidos;
                        dto["institucion"] = "U";
                        dto["institucionDet"] = "Universidad";
                        document.getElementById("universidad").checked = true;
                        dto["nombreInstitucion"] = "Escuela Superior Politécnica del Litoral";
                        dto["email"] = datosbienestar.email;
                        //obtener celular
                        dto["celular"] = this.getCelularFromWsAlumni(ced);
                        //chequear si es graduado de pregrado o graduado de postgrado - PROFESIONAL
                        if (this.esGraduadoPregrado(ced) || this.esGraduadoPostgrado(ced)) {
                            dto["tipoParticipante"] = "P";
                            dto["tipoParticipanteDet"] = "Profesional";
                            document.getElementById("profesional").checked = true;
                        }
                        else {
                            dto["tipoParticipante"] = "E";
                            dto["tipoParticipanteDet"] = "Estudiante";
                            document.getElementById("estudiante").checked = true;
                            //chequear si es estudiante de postgrado
                            if (this.esEstudiantePostgrado(ced)) {
                                dto["tipoEstudiante"] = "A";
                                dto["tipoEstudianteDet"] = "Postgrado";
                                dto["esPostgrado"] = "S";
                                document.getElementById("postgrado").checked = true;
                            }
                            else {
                                //ya en este caso se llena form como estudiante de pregrado
                                dto["tipoEstudiante"] = "B";
                                dto["tipoEstudianteDet"] = "Pregrado";
                                document.getElementById("pregrado").checked = true;
                            }
                        }

                        this.setState({ datosFormulario: dto });
                    }

                });
        }

        catch (error) { console.log("Error: ", error); };
    }

    componentDidMount() {
        this.getCongresoActual();
        //this.getPaises();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.datosFormulario.paises.length === 0) {
            this.getPaises();
        }
    }


    getCongresoActual() {
        fetch(process.env.REACT_APP_URI_SERVER + "api/TblCongresoes/GetCIBBActual")
            .then(response => response.json())
            .then(response => {
                //console.log(response);
                var dto = this.state.datosFormulario;
                var idcongreso = response["idcongreso"];
                dto["idCongreso"] = idcongreso;
                var inicioInscripcion = Date.parse(response["fechainicioinscripcion"]);
                var finInscripcion = Date.parse(response["fechafininscripcion"]);
                var fechaActual = Date.now();
                var tituloCorto = `${response["descripcion"].split(" ")[0]} CIBB ${response["anio"]}`
                //var aceptaRegistro = inicioInscripcion <= fechaActual && fechaActual <= finInscripcion;
                //console.log(aceptaRegistro);
                this.setState({
                    titulo: response["descripcion"],
                    shortitulo: tituloCorto,
                    evento: idcongreso,
                    anioEvento: response["anio"],
                    isDespuesRegInicio: inicioInscripcion <= fechaActual,
                    fechaInicioInsc: String(response["fechainicioinscripcion"]).split("T")[0],
                    isAntesRegFin: fechaActual <= finInscripcion,
                    fechaFinInsc: String(response["fechafininscripcion"]).split("T")[0],
                    datosFormulario: dto
                });
            })
            .catch(error => {
                console.log("Error: ", error);
            })
    }

    getPaises() {
        console.log("Registro Evento ", this.state.datosFormulario.idCongreso)
        //console.log("Llamando funcion get paises");
        fetch("https://ws.espol.edu.ec/rest/api/Pais/getconciudad")
            .then(response => response.json())
            .then(responsejson => {
                var dto = this.state.datosFormulario;
                dto["paises"] = responsejson;
                this.setState({ datosFormulario: dto });
                //console.log(this.state.datosFormulario.paises);
            });
    }


    getCiudades(idPais) {
        var jsonLengthCountries = this.state.datosFormulario.paises.length;
        var dto = this.state.datosFormulario;
        dto.ciudades = [];
        dto.ciudadId = "";
        dto.ciudadNom = "";

        for (let i = 0; i < jsonLengthCountries; i++) {
            if (dto.paises[i].siIdPais === idPais) {
                dto.ciudades = dto.paises[i].listCanton;
            }
        }

        this.setState({ datosFormulario: dto });

    }


    setNomPais(idPais) {
        var dto = this.state.datosFormulario;
        var lengthCountries = dto.paises.length;
        var puesto = 0;

        while (dto.paises[puesto].siIdPais !== idPais && puesto < lengthCountries) {
            puesto++;
        }
        dto.paisNom = this.state.datosFormulario.paises[puesto].strNombre;
        this.setState({ datosFormulario: dto });
    }

    setPaisCedula(idPais) {
        var dto = this.state.datosFormulario;
        dto.paisId = idPais ?? "";
        if (!idPais) {
            dto.paisNom = "";
        }
        this.setState({ datosFormulario: dto });
    }

    setNomCiudad(idCiudad) {
        var dto = this.state.datosFormulario;
        var lengthCities = dto.ciudades.length;
        var puesto = 0;
        while (dto.ciudades[puesto].siIdCanton !== idCiudad && puesto < lengthCities) {
            puesto++;
        }
        dto.ciudadNom = this.state.datosFormulario.ciudades[puesto].strNombreCanton;
        this.setState({ datosFormulario: dto});
    }

    setTipoInstitucionDet() {
        var dto = this.state.datosFormulario;
        if (dto.tipoInstitucion === "E") {
            dto.tipoInstitucionDet = "Empresa";
        }
        if (dto.tipoInstitucion === "U") {
            dto.tipoInstitucionDet = "Universidad";
        }

        this.setState({ datosFormulario: dto });
    }

    setTipoParticipanteDet() {
        var dto = this.state.datosFormulario;
        if (dto.tipoParticipante === "P") {
            dto.tipoParticipanteDet = "Profesional";
        }
        if (dto.tipoParticipante === "E") {
            dto.tipoParticipanteDet = "Estudiante";
        }

        this.setState({ datosFormulario: dto });
    }

    setTipoEstudianteDet() {
        var dto = this.state.datosFormulario;
        if (dto.tipoEstudiante === "B") {
            dto.tipoEstudianteDet = "Pregrado";
        }
        if (dto.tipoEstudiante === "A") {
            dto.tipoEstudianteDet = "Postgrado";
        }

        this.setState({ datosFormulario: dto });
    }

    setTipoParticipacionDet() {
        var dto = this.state.datosFormulario;
        if (dto.tipoParticipacion === "O") {
            dto.tipoParticipacionDet = "Presentación Oral";
            dto.tipoAsistencia = "P";
        }
        if (dto.tipoParticipacion === "P") {
            dto.tipoParticipacionDet = "Presentación Cartel";
            dto.tipoAsistencia = "P";
        }
        if (dto.tipoParticipacion === "A") {
            dto.tipoParticipacionDet = "Asistente";
        }
        
        this.setState({ datosFormulario: dto });
    }


    setModoInformadoDet() {
        var dto = this.state.datosFormulario;
        if (dto.modoInformado === "R") {
            dto.modoInformadoDet = "Redes Sociales";
        }
        if (dto.modoInformado === "P") {
            dto.modoInformadoDet = "Página Web";
        }
        if (dto.modoInformado === "C") {
            dto.modoInformadoDet = "Correo Electrónico";
        }
        if (dto.modoInformado === "O") {
            dto.modoInformadoDet = "Otros";
        }
        this.setState({ datosFormulario: dto });
    }

    setEsEspolDet() {
        var dto = this.state.datosFormulario;
        if (dto.esEspol === "S") {
            dto.esEspolDet = "Sí";
        }
        if (dto.esEspol === "N") {
            dto.esEspolDet = "No";
        }

        this.setState({ datosFormulario: dto });
    }

    setEsPostgradoDet() {
        var dto = this.state.datosFormulario;
        if (dto.esPostgrado === "S") {
            dto.esPostgradoDet = "Sí";
        }
        if (dto.esPostgrado === "N") {
            dto.esPostgradoDet = "No";
        }

        this.setState({ datosFormulario: dto });
    }

    

    setCibbValor() {
        var fechaCorte = new Date(2022, 5, 30);
        var dto = this.state.datosFormulario;
        if (new Date() > fechaCorte) {
            if (dto.esEspol === "S") {
                if (dto.tipoParticipante === "P" || dto.tipoestudiante === "A") {
                    dto.valorCIBB = 135.00;
                }
                else {
                    dto.valorCIBB = 67.50;
                }                
            }
            else {
                if (dto.tipoParticipante === "P" || dto.tipoestudiante === "A") {
                    dto.valorCIBB = 150.00;
                }
                else {
                    dto.valorCIBB = 75.00;
                }
            }

        }
        else {
            if (dto.esEspol === "S") {
                if (dto.tipoParticipante === "P" || dto.tipoestudiante === "A") {
                    dto.valorCIBB = 90.00;
                }
                else {
                    dto.valorCIBB = 45.00;
                }
            }
            else {
                if (dto.tipoParticipante === "P" || dto.tipoestudiante === "A") {
                    dto.valorCIBB = 100.00;
                }
                else {
                    dto.valorCIBB = 50.00;
                }
            }
        }
        this.setState({ datosFormulario: dto });
    }


    getCelularFromWsAlumni(ced) {
        try {
            fetch("https://wsalumni.espol.edu.ec/api/Informacion/GetIdPersona/" + ced)
                .then(response => response.json())
                .then(responsejson => {                 
                    var datosgrado = responsejson["tdatosalumni"];
                    var numCelular = null;
                    if (datosgrado !== null) {
                        numCelular = datosgrado.codarea + datosgrado.telefonocelular;
                    }
                    //console.log("El número celular de " + ced + " es " + numCelular);
                    return numCelular;
                });
        }

        catch (error) { console.log("Error: ", error); }
    }


    esGraduadoPregrado(ced) {
        try {
            fetch("https://wsalumni.espol.edu.ec/api/Informacion/GetIdPersona/" + ced)
                .then(response => response.json())
                .then(responsejson => {
                    var datosgrado = responsejson["tdatosalumni"];
                    if (datosgrado !== null) {
                        //console.log("Persona con cédula " + ced + " es graduado de pregrado.");
                        return true;
                    }
                    else {
                        //console.log("Persona con cédula " + ced + " no es graduado de pregrado.");
                        return false;
                    }
                })
        }

        catch (error) { console.log("Error: ", error); }
    }


    esGraduadoPostgrado(ced) {
        //console.log("Llamando a la funcion esGraduadoPostgrado");
        try {
            fetch('api/Postgrado/IsPostgrado' + ced)
                //.then(res => res.json())
                .then(resjson => {
                    //console.log("Esto es lo que me devuelve la funcion esGraduadoPostgrado");
                    //console.log(resjson);
                    if (resjson.strEstado === "S") {
                        if (resjson.esGraduadoPost) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                })
        }

        catch (error) { console.log("Error: ", error); };
    }
    

    esEstudiantePostgrado(ced) {
        //console.log("Llamando a la funcion esEstudiantePostgrado");
        try {
            fetch('Postgrado/IsPostgrado/' + ced)
                //.then(res => res.json())
                .then(resjson => {
                    //console.log("Esto es lo que me devuelve la funcion esEstudiantePostgrado");
                    //console.log(resjson);
                    if (resjson.strEstado === "S") {
                        if (resjson.esEstudiantePost) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }
                }
                );
        }

        catch (error) { console.log("Error: ", error); };        
        
    }

    handleBlur(e) {
        fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/Registrado/` +
            this.state.datosFormulario.numeroIdentificacion + "/" +
            this.state.datosFormulario.paisId + "/" +
            this.state.datosFormulario.idCongreso + "/" + 
            this.state.datosFormulario.tipoParticipacion)
            .then(res => res.json())
            .then(data => {
                var dto = this.state.datosFormulario;
                var pagadoResult = data.tblCibbRegistro.pagado;
                dto["pagado"] = pagadoResult;
                //console.log(data.tblCibbRegistro.rutaComprobante)
                let isregistrado = pagadoResult == 2 || (pagadoResult == 1 && data.tblCibbRegistro.rutaComprobante != null) /*|| (pagadoResult == 1 && data.tblCibbRegistro.rutapresentacion != null)*/
                this.setState({ isRegistrado: isregistrado, datosFormulario: dto });
                //console.log(this.state.datosFormulario.pagado);
            })
            .catch(e => {
                console.log(e);
                var dto = this.state.datosFormulario;
                dto["pagado"] = 1;
                this.setState({ isRegistrado: false, datosFormulario: dto });
                //console.log(this.state.datosFormulario.pagado);
            })
    };


    handleChange(e) {
        //console.log("propery: ", e.target.name);
        //console.log("value: ", e.target.value);
        var dto = this.state.datosFormulario;
        dto[e.target.name] = e.target.value;
        this.setState({ datosFormulario: dto });
        if (e.target.id === "cedula" && e.target.value.length === 10) {
            //console.log("en if de cedula");
            var cedula = this.state.datosFormulario.numeroIdentificacion;
            this.getDatosEspol(cedula);
        }

        if (e.target.name === "paisId") {
            this.getCiudades(Number(e.target.value));
            this.setNomPais(Number(e.target.value));
        }

        if (e.target.name === "tipoIdentificacion") {
            if (e.target.value === "C") {
                this.getCiudades(1);
                this.setNomPais(1);
                this.setPaisCedula("1");
            }
            else {
                this.getCiudades(0);
                this.setPaisCedula(null);
            }
        }


        if (e.target.name === "ciudadId") {
            this.setNomCiudad(Number(e.target.value));
        }

        if (e.target.name === "tipoInstitucion") {
            //console.log(e.target.value)
            this.setTipoInstitucionDet();
        }

        if (e.target.name === "tipoParticipante") {
            //console.log(e.target.value)
            this.setTipoParticipanteDet();
        }

        if (e.target.name === "tipoEstudiante") {
            //console.log(e.target.value)
            this.setTipoEstudianteDet();
        }

        if (e.target.name === "tipoParticipacion") {
            //console.log(e.target.value)
            this.setTipoParticipacionDet();
        }

        if (e.target.name === "aceptaAvisoTraDatos") {
            dto.aceptaAvisoTraDatos = e.target.checked;
            this.setState({ datosFormulario: dto });
        }

        if (e.target.name === "modoInformado") {
            //console.log(e.target.value)
            this.setModoInformadoDet();
        }
        //console.log(this.state.datosFormulario)
    }


    uploadFile = (id) => {
        //creating form data object and append file into that form data
        this.setState({ isLoading: true });
        let formData = new FormData();
        formData.append("file", document.getElementById("presentacion").files[0]);
        formData.append("idCongresoRegistro", id);
        formData.append("Pais", this.state.datosFormulario.paisNom);
        formData.append("Ciudad", this.state.datosFormulario.ciudadNom);
        formData.append("Instituciondet", this.state.datosFormulario.tipoInstitucionDet);
        formData.append("Tipoparticipantedet", this.state.datosFormulario.tipoParticipanteDet);
        formData.append("Tipoestudiantedet", this.state.datosFormulario.tipoEstudianteDet);
        formData.append("Participaciondet", this.state.datosFormulario.tipoParticipacionDet);
        formData.append("Modoinformadodet", this.state.datosFormulario.modoInformadoDet);

        fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/SubirDocumento`, {

        //con dirección de prueba del backend
        //fetch("http://192.168.253.6:8091/api/TblCibbRegistroes/SubirDocumento", {

        //fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/SubirDocumento", {
            method: "POST",
            //headers: {
            //    'Content-Type': 'multipart/form-data'
            //},
            body: formData
        }).then(res => {
            this.setState({ isLoading: false });
            if (res.status == 200) {
                Swal.fire({
                    title: `¡Pre-registro exitoso!`,
                    text: `Usted ha sido Pre-registrado en el ${this.state.shortitulo}. Se ha enviado su resumen al Comité Científo del CIBB para su aprobación. Pronto nos contactaremos con usted.`,
                    //imageUrl: { iconEnvioDoc },
                    iconHtml: `<img style="width:70;height:50" src=${iconEnvioDoc}>`,
                    //imageWidth: 200,
                    //imageHeight: 200,
                    imageAlt: "Ícono de prerregistro"
                }).then(
                    function () {
                        window.location.reload();
                    });
            }
            else {
                Swal.fire({
                    title: `¡Pre-registro fallido!`,
                    text: `No se ha podido subir el documento de presentación al comité del CIBB para su aprobación. Intente más tarde.`,
                    icon: "error"
                }).then(_ => {
                    window.grecaptcha.reset();
                    this.handleRecaptchaChange(null);
                });
            }
        }).catch((error) => {
                Swal.fire({
                    title: `¡Pre-registro fallido!`,
                    text: `No se ha podido subir el documento de presentación al comité del CIBB para su aprobación. Intente más tarde.`,
                    icon: "error"
                }).then(_ => {
                    window.grecaptcha.reset();
                    this.handleRecaptchaChange(null);
                });
                console.log(error);
            });
    }



    uploadComprobante = (id) => {
        //creating form data object and append file into that form data
        let formData = new FormData();
        formData.append("file", document.getElementById("comprobantePago").files[0]);
        formData.append("idRegistroCIBB", id);
        formData.append("pais", this.state.datosFormulario.paisNom);
        formData.append("ciudad", this.state.datosFormulario.ciudadNom);
        formData.append("institucionDet", this.state.datosFormulario.tipoInstitucionDet);
        formData.append("tipoParticipanteDet", this.state.datosFormulario.tipoParticipanteDet);
        formData.append("tipoEstudianteDet", this.state.datosFormulario.tipoEstudianteDet);
        formData.append("participacionDet", this.state.datosFormulario.tipoParticipacionDet);
        formData.append("modoInformadoDet", this.state.datosFormulario.modoInformadoDet);

        fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/SubirComprobante`, {
            method: "POST",
            //headers: {
            //    'Content-Type': 'multipart/form-data'
            //},
            body: formData
        }).then(res => {
            this.setState({ isLoading: false });
            //console.log(res);
            if (res.status == 200) {
                Swal.fire({
                    title: "¡Comprobante subido exitosamente!",
                    text: "Usted ha completado su registro.",
                    icon: "success"
                }).then(
                    function () {
                        window.location.reload();
                    });
            } else {
                Swal.fire({
                    title: "¡El comprobante no se pudo guardar!",
                    text: "Por favor, vuelva a registrarse más tarde.",
                    icon: "error"
                }).then(_ => {
                    window.grecaptcha.reset();
                    this.handleRecaptchaChange(null);
                });
            }

        }).catch((error) => {
                console.log(error);
                this.setState({ isLoading: false });
            });
    }


    validarFormulario = () => {
        //console.log("Lamando funcion validarFormulario");
        var dto = this.state.datosFormulario;
        const maxAllowedSize = 20 * 1024 * 1024;
        //console.log(dto);
        if (
            (dto.tipoIdentificacion === "C" && !this.expresiones.cedula.test(this.state.datosFormulario.numeroIdentificacion)) ||
            (dto.tipoIdentificacion === "P" && !this.expresiones.pasaporte.test(this.state.datosFormulario.numeroIdentificacion)) ||
            !this.expresiones.nombre.test(this.state.datosFormulario.nombres) ||
            !this.expresiones.nombre.test(this.state.datosFormulario.apellidos) ||
            dto.paisId === "" ||
            dto.ciudadId === "" ||
            dto.tipoInstitucion === "" ||
            dto.nombreInstitucion === "" ||
            //!this.expresiones.nombreinstitucion.test(this.state.datosFormulario.nombreInstitucion) ||
            dto.tipoParticipante === "" ||
            (dto.tipoParticipante === "E" && dto.tipoEstudiante === "") ||
            !this.expresiones.correo.test(this.state.datosFormulario.email) ||
            !this.expresiones.telefono.test(this.state.datosFormulario.celular) ||
            dto.tipoParticipacion === "" ||
            (dto.tipoParticipacion !== "A" && dto.presentacion === "") ||
            dto.modoInformado === "" ||
            (dto.modoInformado === "O" && dto.otroModoInformado === "") || (dto.formaPago === "B" && document.getElementById("comprobantePago").files[0] == undefined)
        ) {
            //console.log("Eligio cedula y no se ajusta a regex: ", dto.tipoIdentificacion === "C" && !this.expresiones.cedula.test(this.state.datosFormulario.numeroIdentificacion));
            //console.log("Eligio pasaporte y no se ajusta a regex: ", dto.tipoIdentificacion === "P" && !this.expresiones.pasaporte.test(this.state.datosFormulario.numeroIdentificacion));
            //console.log("nombre ", !this.expresiones.nombre.test(this.state.datosFormulario.nombres));
            //console.log("apellidos", !this.expresiones.nombre.test(this.state.datosFormulario.apellidos));
            //console.log("pais", dto.paisId === "");
            //console.log("ciudad", dto.ciudadId === "");
            //console.log("tipo institucion", dto.tipoInstitucion === "");
            //console.log("nombreinstitucion", !this.expresiones.nombre.test(this.state.datosFormulario.nombreInstitucion));
            //console.log("tipo participante", dto.tipoParticipante === "");
            //console.log("tipo estudiante", (dto.tipoParticipante === "E" && dto.tipoEstudiante === ""));
            //console.log("correo", !this.expresiones.correo.test(this.state.datosFormulario.email));
            //console.log("celular", !this.expresiones.cedula.test(this.state.datosFormulario.celular));
            //console.log("tipo participacion", dto.tipoParticipacion === "");
            //console.log("presentacion", dto.tipoParticipacion !== "A" && dto.presentacion === "");
            //console.log("modo informado", dto.modoInformado === "");
            //console.log("otro modo informado", (dto.modoInformado === "O" && dto.otroModoInformado === ""));

            return false
        }
        if (dto.tipoParticipacion == "A" && dto.formaPago === "B") {
            if (document.getElementById("comprobantePago").files[0]?.size > maxAllowedSize) {
                // Here you can ask your users to load correct file
                document.getElementById("comprobantePago").value = ''
                return false
            }
        }
        if (dto.tipoParticipacion !== "A") {
            if (document.getElementById("presentacion").files[0]?.size > maxAllowedSize) {
                // Here you can ask your users to load correct file
                document.getElementById("presentacion").value = ''
                return false
            }
        } 
        if (dto.tipoParticipacion !== "A") {
            if (!/\.(docx?)$/i.test(dto.presentacion)) {
                // Here you can ask your users to load correct file
                document.getElementById("presentacion").value = ''
                return false
            }
        }

        return true
    }

    showTermsTratamiento() {
        Swal.fire({
            html: TratamientoDatosCibbString(),
            width: "40vw",
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            focusConfirm: false,
            showClass: {
                popup: `
                    animate__animated
                    animate__fadeInUp
                    animate__faster
                `
            },
            hideClass: {
                popup: `
                    animate__animated
                    animate__fadeOutDown
                    animate__faster
                `
            },
            confirmButtonText: `Aceptar`
        }).then((result) => {
            if (result.isConfirmed) {
                var element = document.getElementById("aceptaAvisoTraDatos");
                element.checked = true;
                element.setCustomValidity("");
                this.handleChange({ target: element })
            }
        })
    }

    onSubmit = (e) => {
        //console.log(this.validarFormulario());
        e.preventDefault();
        if (!this.state.onProcess) {

            if (!this.state.recaptchaToken) {
                alert("No ha completado el reCAPTCHA.");
                return
            }

            this.setState({
                onProcess: true
            });

            if (this.validarFormulario()) {
                //var estadoPagado;
                var idCibb;
                this.setState({ isLoading: true });
                //con API local
                fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/Registrado/` +

                    //con dirección de prueba del backend
                    //fetch("http://192.168.253.6:8091/api/TblCibbRegistroes/Registrado/" +

                    //con API de producción
                    //fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/Registrado/" +
                    this.state.datosFormulario.numeroIdentificacion + "/" +
                    this.state.datosFormulario.paisId + "/" +
                    this.state.datosFormulario.idCongreso + "/" +
                    this.state.datosFormulario.tipoParticipacion)
                    .then(res => res.json())
                    .then(data => {
                        this.setState({ isLoading: false });
                        //revisar si el participante ya está registrado
                        if (data.strEstado === "N") {
                            //crear registro
                            e.preventDefault();
                            this.setCibbValor();
                            const POST_CIBB = JSON.stringify({
                                "apellidos": this.state.datosFormulario.apellidos,
                                "nombres": this.state.datosFormulario.nombres,
                                "numeroidentificacion": this.state.datosFormulario.numeroIdentificacion,
                                "idpais": this.state.datosFormulario.paisId,
                                "pais": this.state.datosFormulario.paisNom,
                                "idcanton": this.state.datosFormulario.ciudadId,
                                "ciudad": this.state.datosFormulario.ciudadNom,
                                "tipoinstitucion": this.state.datosFormulario.tipoInstitucion,
                                "instituciondet": this.state.datosFormulario.tipoInstitucionDet,
                                "nombreinstitucion": this.state.datosFormulario.nombreInstitucion,
                                "tipoparticipante": this.state.datosFormulario.tipoParticipante,
                                "tipoparticipantedet": this.state.datosFormulario.tipoParticipanteDet,
                                "tipoestudiante": this.state.datosFormulario.tipoEstudiante,
                                "tipoestudiantedet": this.state.datosFormulario.tipoEstudianteDet,
                                "email": this.state.datosFormulario.email,
                                "celular": this.state.datosFormulario.celular,
                                "tipoparticipacion": this.state.datosFormulario.tipoParticipacion,
                                "participaciondet": this.state.datosFormulario.tipoParticipacionDet,
                                "rutapresentacion": this.state.datosFormulario.presentacion,
                                "modoinformado": this.state.datosFormulario.modoInformado,
                                "modoinformadodet": this.state.datosFormulario.modoInformadoDet,
                                "otromodoinformado": this.state.datosFormulario.otroModoInformado,
                                "esespol": this.state.datosFormulario.esEspol,
                                "fecharegistro": new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                                "aniocongreso": this.state.datosFormulario.anioCongreso,
                                "pagado": this.state.datosFormulario.pagado,
                                "idcongreso": this.state.datosFormulario.idCongreso,
                                "tipoasistencia": this.state.datosFormulario.tipoAsistencia,
                                "aceptaavisotradatos": this.state.datosFormulario.aceptaAvisoTraDatos ? "S" : "N",
                            });
                            //Dirección local del backend
                            this.setState({ isLoading: true });
                            fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/Guardar`, {

                                //Dirección de prueba del backend:
                                //fetch("http://192.168.253.6:8091/api/TblCibbRegistroes/Guardar", {

                                //fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/Guardar", {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'X-Recaptcha-Token': this.state.recaptchaToken },
                                body: POST_CIBB
                            })
                                .then(res => res.json())
                                .then(data => {
                                    //console.log(data);
                                    if (data.rutapresentacion !== null && data.rutapresentacion !== "") {
                                        this.setState({ isLoading: true });
                                        this.uploadFile(data.idcongresoregistro);
                                    }
                                    Swal.fire({
                                        title: `Iniciando ${(data.rutapresentacion !== null && data.rutapresentacion !== "") ? "Pre-registro" : "Registro"}...`,
                                        text: `${(data.rutapresentacion !== null && data.rutapresentacion !== "") ? "Subiendo documento de presentación..." : "Procesando método de pago..."}`,
                                        icon: "info"
                                    });
                                    if (this.state.datosFormulario.tipoParticipacion === "A" &&
                                        this.state.datosFormulario.formaPago === "T") {
                                        Swal.fire({
                                            title: "Redireccionando...",
                                            text: "Redireccionando a página de pago.",
                                            icon: "success"
                                        });
                                        //Crear transaccion
                                        this.setState({ isLoading: true });
                                        fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/CrearTransaccionAPI`, {
                                            //con a dirección de prueba
                                            //fetch("http://192.168.253.6:8091/api/TblCibbRegistroes/CrearTransaccionAPI", {
                                            //fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/CrearTransaccionAPI", {                        
                                            method: 'POST',
                                            headers: { 'Content-Type': 'application/json' },
                                            body: JSON.stringify({
                                                "idcongresoregistro": data.idcongresoregistro,
                                                "apellidos": this.state.datosFormulario.apellidos,
                                                "nombres": this.state.datosFormulario.nombres,
                                                "numeroidentificacion": this.state.datosFormulario.numeroIdentificacion,
                                                "idpais": this.state.datosFormulario.paisId,
                                                "idcanton": this.state.datosFormulario.ciudadId,
                                                "tipoinstitucion": this.state.datosFormulario.tipoInstitucion,
                                                "nombreinstitucion": this.state.datosFormulario.nombreInstitucion,
                                                "tipoparticipante": this.state.datosFormulario.tipoParticipante,
                                                "tipoestudiante": this.state.datosFormulario.tipoEstudiante,
                                                "email": this.state.datosFormulario.email,
                                                "celular": this.state.datosFormulario.celular,
                                                "tipoparticipacion": this.state.datosFormulario.tipoParticipacion,
                                                "rutapresentacion": this.state.datosFormulario.presentacion,
                                                "modoinformado": this.state.datosFormulario.modoInformado,
                                                "otromodoinformado": this.state.datosFormulario.otroModoInformado,
                                                "esespol": this.state.datosFormulario.esEspol,
                                                "fecharegistro": new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                                                "aniocongreso": this.state.datosFormulario.anioCongreso,
                                                "pagado": this.state.datosFormulario.pagado,
                                                "idcongreso": this.state.datosFormulario.idCongreso,
                                                "tipoasistencia": this.state.datosFormulario.tipoAsistencia,
                                                "pais": this.state.datosFormulario.paisNom,
                                                "ciudad": this.state.datosFormulario.ciudadNom,
                                                "instituciondet": this.state.datosFormulario.tipoInstitucionDet,
                                                "tipoparticipantedet": this.state.datosFormulario.tipoParticipanteDet,
                                                "tipoestudiantedet": this.state.datosFormulario.tipoEstudianteDet,
                                                "participaciondet": this.state.datosFormulario.tipoParticipacionDet,
                                                "modoinformadodet": this.state.datosFormulario.modoInformadoDet,
                                                "esespoldet": this.state.datosFormulario.esEspolDet,
                                                "espostgradodet": this.state.datosFormulario.esPostgradoDet,
                                                "valorcongreso": this.state.datosFormulario.valorCIBB,
                                                "aceptaavisotradatos": this.state.datosFormulario.aceptaAvisoTraDatos ? "S" : "N",
                                            })
                                        })
                                            .then(res => res.json())
                                            .then(data => {

                                                this.setState({ isLoading: false });
                                                // if data.estado === 0 fue exitoso y hago la redireccion a la pagina de pago
                                                if (data.estado === 0 && data.item !== null) {
                                                    window.location.href = process.env.REACT_APP_URI_PAGOS + data.item.strToken;
                                                    //window.location.href = "https://pagos.espol.edu.ec/pago/" + data.item.strToken;
                                                }
                                                // else se produjo un error, presentar Swal con data.mensaje
                                                else {
                                                    Swal.fire({
                                                        title: "No se pudo completar el registro con el sistema de pago.",
                                                        text: (data.mensaje ?? "Error interno.") + " Vuelva a intentarlo más tarde.",
                                                        icon: "error"
                                                    }).then(_ => {
                                                        window.grecaptcha.reset();
                                                        this.handleRecaptchaChange(null);
                                                    });
                                                }
                                            });
                                    }

                                    if (this.state.datosFormulario.tipoParticipacion === "A" &&
                                        this.state.datosFormulario.formaPago === "B") {
                                        //guardar comprobante de pago
                                        this.setState({ isLoading: true });
                                        this.uploadComprobante(data.idcongresoregistro);
                                    }

                                }).catch((error) => {
                                    console.log(error);
                                    this.setState({ isLoading: false });
                                    Swal.fire({
                                        title: "No se pudo completar el registro.",
                                        text: "Datos ingresados no válidos. Vuelva a ingresar los datos.",
                                        icon: "error"
                                    }).then(_ => {
                                        window.grecaptcha.reset();
                                        this.handleRecaptchaChange(null);
                                    });
                                });
                                //.catch((error) => { console.log(error); });
                        }

                        else if (!this.state.isRegistrado) {
                            //Swal.fire({
                            //    title: "Participante ya registrado.",
                            //    text: "Usted ya se encuentra registrado para el congreso.",
                            //    icon: "warning"
                            //})
                            //return;
                            //actualizar registro
                            Swal.fire({
                                title: 'Participación ya registrada. ¿Desea actualizar su información?',
                                icon: 'question',
                                showDenyButton: true,
                                showCancelButton: true,
                                showCancelButton: false,
                                confirmButtonText: 'Actualizar',
                                denyButtonText: 'Cancelar',
                            }).then((result) => {
                                if (result.isConfirmed) {


                                    e.preventDefault();
                                    this.setCibbValor();
                                    idCibb = data.tblCibbRegistro.idcongresoregistro;
                                    const PUT_CIBB = JSON.stringify({
                                        "idcongresoregistro": idCibb,
                                        "apellidos": this.state.datosFormulario.apellidos,
                                        "nombres": this.state.datosFormulario.nombres,
                                        "numeroidentificacion": data.tblCibbRegistro.numeroidentificacion,
                                        "idpais": data.tblCibbRegistro.idpais,
                                        "idcanton": data.tblCibbRegistro.idcanton,
                                        "tipoinstitucion": this.state.datosFormulario.tipoInstitucion,
                                        "nombreinstitucion": this.state.datosFormulario.nombreInstitucion,
                                        "tipoparticipante": this.state.datosFormulario.tipoParticipante,
                                        "tipoestudiante": this.state.datosFormulario.tipoEstudiante,
                                        "email": this.state.datosFormulario.email,
                                        "celular": this.state.datosFormulario.celular,
                                        "tipoparticipacion": this.state.datosFormulario.tipoParticipacion,
                                        "rutapresentacion": this.state.datosFormulario.presentacion,
                                        "modoinformado": this.state.datosFormulario.modoInformado,
                                        "otromodoinformado": this.state.datosFormulario.otroModoInformado,
                                        "esespol": this.state.datosFormulario.esEspol,
                                        "pagado": data.tblCibbRegistro.pagado,
                                        "fecharegistro": data.tblCibbRegistro.fecharegistro,
                                        "aniocongreso": this.state.datosFormulario.anioCongreso,
                                        "idcongreso": data.tblCibbRegistro.idcongreso,
                                        "tipoasistencia": this.state.datosFormulario.tipoAsistencia,
                                        "aceptaavisotradatos": this.state.datosFormulario.aceptaAvisoTraDatos ? "S" : "N",
                                    });
                                    this.setState({ isLoading: true });
                                    fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/` + idCibb, {

                                        //con dirección de prueba
                                        //fetch("http://192.168.253.6:8091/api/TblCibbRegistroes/" + idCibb, {

                                        //fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/" + idCibb, {
                                        method: 'PUT',
                                        headers: { 'Content-Type': 'application/json', 'X-Recaptcha-Token': this.state.recaptchaToken },
                                        body: PUT_CIBB
                                    })
                                        .then(res => res.json())
                                        .then(data => {
                                            if (data.rutapresentacion !== null && data.rutapresentacion !== "") {
                                                this.uploadFile(data.idcongresoregistro);
                                            }
                                            //this.setState({ isLoading: false });
                                            //Swal.fire({
                                            //    title: "¡Actualización exitosa!",
                                            //    text: "Sus datos han sido actualizados en el CIBB.",
                                            //    icon: "success"
                                            //});
                                            Swal.fire({
                                                title: `Actualizando ${(data.rutapresentacion !== null && data.rutapresentacion !== "") ? "Pre-registro" : "Registro"}...`,
                                                text: `${(data.rutapresentacion !== null && data.rutapresentacion !== "") ? "Actualizando documento de presentación..." : "Procesando método de pago..."}`,
                                                icon: "info"
                                            });
                                            if (this.state.datosFormulario.tipoParticipacion === "A" &&
                                                this.state.datosFormulario.formaPago === "T") {
                                                Swal.fire({
                                                    title: "Redireccionando...",
                                                    text: "Redireccionando a página de pago.",
                                                    icon: "success"
                                                });
                                                this.setState({ isLoading: true });
                                                //Crear transaccion
                                                fetch(`${process.env.REACT_APP_URI_SERVER}api/TblCibbRegistroes/CrearTransaccionAPI`, {

                                                    //con direccion de prueba
                                                    //fetch("http://192.168.253.6:8091/api/TblCibbRegistroes/CrearTransaccionAPI", {

                                                    //fetch("https://wsregistrocibb.espol.edu.ec/api/TblCibbRegistroes/CrearTransaccionAPI", {
                                                    method: 'POST',
                                                    headers: { 'Content-Type': 'application/json' },
                                                    body: JSON.stringify({
                                                        "idcongresoregistro": idCibb,
                                                        "apellidos": this.state.datosFormulario.apellidos,
                                                        "nombres": this.state.datosFormulario.nombres,
                                                        "numeroidentificacion": this.state.datosFormulario.numeroIdentificacion,
                                                        "idpais": this.state.datosFormulario.paisId,
                                                        "idcanton": this.state.datosFormulario.ciudadId,
                                                        "tipoinstitucion": this.state.datosFormulario.tipoInstitucion,
                                                        "nombreinstitucion": this.state.datosFormulario.nombreInstitucion,
                                                        "tipoparticipante": this.state.datosFormulario.tipoParticipante,
                                                        "tipoestudiante": this.state.datosFormulario.tipoEstudiante,
                                                        "email": this.state.datosFormulario.email,
                                                        "celular": this.state.datosFormulario.celular,
                                                        "tipoparticipacion": this.state.datosFormulario.tipoParticipacion,
                                                        "rutapresentacion": this.state.datosFormulario.presentacion,
                                                        "modoinformado": this.state.datosFormulario.modoInformado,
                                                        "otromodoinformado": this.state.datosFormulario.otroModoInformado,
                                                        "esespol": this.state.datosFormulario.esEspol,
                                                        "fecharegistro": new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
                                                        "aniocongreso": this.state.datosFormulario.anioCongreso,
                                                        "pagado": this.state.datosFormulario.pagado,
                                                        "idcongreso": this.state.datosFormulario.idCongreso,
                                                        "tipoasistencia": this.state.datosFormulario.tipoAsistencia,
                                                        "pais": this.state.datosFormulario.paisNom,
                                                        "ciudad": this.state.datosFormulario.ciudadNom,
                                                        "instituciondet": this.state.datosFormulario.tipoInstitucionDet,
                                                        "tipoparticipantedet": this.state.datosFormulario.tipoParticipanteDet,
                                                        "tipoestudiantedet": this.state.datosFormulario.tipoEstudianteDet,
                                                        "participaciondet": this.state.datosFormulario.tipoParticipacionDet,
                                                        "modoinformadodet": this.state.datosFormulario.modoInformadoDet,
                                                        "esespoldet": this.state.datosFormulario.esEspolDet,
                                                        "espostgradodet": this.state.datosFormulario.esPostgradoDet,
                                                        "valorcongreso": this.state.datosFormulario.valorCIBB,
                                                        "aceptaavisotradatos": this.state.datosFormulario.aceptaAvisoTraDatos ? "S" : "N",
                                                    })
                                                })
                                                    .then(res => res.json())
                                                    .then(data => {
                                                        //console.log(data);
                                                        this.setState({ isLoading: false });
                                                        // if data.estado === 0 fue exitoso y hago la redireccion a la pagina de pago
                                                        if (data.estado === 0 && data.item !== null) {
                                                            window.location.href = process.env.REACT_APP_URI_PAGOS + data.item.strToken;
                                                            //window.location.href = "https://testpostgrado.espol.edu.ec/pago/" + data.item.strToken;
                                                        }
                                                        // else se produjo un error, presentar Swal con data.mensaje
                                                        else {
                                                            Swal.fire({
                                                                title: "No se pudo completar el registro con el sistema de pago.",
                                                                text: (data.mensaje ?? "Error interno.") + " Vuelva a intentarlo más tarde.",
                                                                icon: "error"
                                                            }).then(_ => {
                                                                window.grecaptcha.reset();
                                                                this.handleRecaptchaChange(null);
                                                            });
                                                        }
                                                    }).catch((error) => {
                                                        console.log(error);
                                                        this.setState({ isLoading: false });
                                                        window.grecaptcha.reset();
                                                        this.handleRecaptchaChange(null);
                                                    });
                                            }

                                            if (this.state.datosFormulario.tipoParticipacion === "A" &&
                                                this.state.datosFormulario.formaPago === "B") {
                                                //guardar comprobante de pago
                                                this.setState({ isLoading: true });
                                                this.uploadComprobante(idCibb);
                                            }

                                        }).catch((error) => {
                                            console.log(error);
                                            this.setState({ isLoading: false });
                                            window.grecaptcha.reset();
                                            this.handleRecaptchaChange(null);
                                        });
                                /*.catch((error) => { console.log(error); });*/



                                } else if (result.isDenied) {
                                    Swal.fire('Datos no actualizados', '', 'info')
                                    window.grecaptcha.reset();
                                    this.handleRecaptchaChange(null);
                                }
                            })
                            

                        }
                        else (
                            //Swal.fire({
                            //    title: "¡Formulario no válido!",
                            //    text: "Usuario ya registrado.",
                            //    icon: "error"
                            //})
                            Swal.fire({
                                title: "Participante ya registrado.",
                                text: "Usted ya se encuentra registrado para el congreso.",
                                icon: "warning"
                            }).then(_ => {
                                window.grecaptcha.reset();
                                this.handleRecaptchaChange(null);
                            })
                        )

                    });

            }
            else {
                Swal.fire({
                    title: "¡Formulario no válido!",
                    text: "Asegúrese de llenar todos los campos obligatorios (campos con asterisco *), 10 dígitos en cédula o mínimo 5 caracteres en pasaporte y los archivos no deben superar los 20MB y el archivo de presentación (si corresponde) sea un archivo Word.",
                    icon: "error"
                }).then(_ => {
                    window.grecaptcha.reset();
                    this.handleRecaptchaChange(null);
                })
                    ;
            }
            e.preventDefault();

            this.setState({
                onProcess: false
            });
        }
        
    }


    getEstadoEstudiante = (ced) => {
        const estadoEstudianteRequest = `<?xml version="1.0" encoding="utf-8"?>
<soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
  <soap:Body>
    <EstadoEstudiante xmlns="http://academico.espol.edu.ec/webservices/">
      <cedula>ced</cedula>
    </EstadoEstudiante>
  </soap:Body>
</soap:Envelope>`;

        fetch("https://ws.espol.edu.ec/saac/WSSAAC.asmx", {
            method: 'POST',
            headers: {
                'Host': 'ws.espol.edu.ec',
                'Content-Type': 'text/xml; charset=utf-8',
                'SOAPAction': "http://academico.espol.edu.ec/webservices/EstadoEstudiante"
            },
            body: estadoEstudianteRequest
        })
            .then((response) => console.log(response));
    }



    //render() {
    //    var contenido = this.state.datosFormulario.paises.length > 0 ?
    //        this.renderFormulario()
    //        :
    //        <div>
    //            <div className="spinner-border" role="status">
    //                <span className="visually-hidden"></span>
    //            </div>
    //            <span>Cargando...</span>
    //        </div>        

    //    return (
    //        <div>
    //            {contenido}
    //        </div>
    //    );
    //}

    render() {
        var contenido = (this.state.datosFormulario.paises.length > 0 &&
            this.state.evento !== 0) ?
            <>
                <center>
                    {/*<h4 style={{ marginTop: "10px" }}>VII Congreso Internacional de Biotecnolog&iacute;a y Biodiversidad 2025</h4>*/}
                    <h4 style={{ marginTop: "10px" }}>{this.state.titulo}</h4>
                    {/*<h5>CIBB 2025</h5>*/}
                    {/*<h5>- MODALIDAD VIRTUAL -</h5>*/}
                </center>
                {/*<br />*/}
                {/*<h5>Formulario de Registro: VII CIBB 2025</h5>*/}
                <br />
                {this.renderFormulario()}
            </>

            :
            (this.state.evento == 0 ?
                <div>
                    <span>Evento no disponible</span>
                </div>
                :
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "5px", fontSize: "16pt", marginTop: "10px" }}>
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden"></span>
                    </div>
                    <span><strong>Cargando Formulario...</strong></span>
                </div>
            )

        return (
            <div>
                {contenido}
            </div>
        );
    }

    formatDateString(strDate) {
        //strDate yyyy-mm-dd
        if (this.expresiones.fecha1.test(strDate)) {
            return new Date(`${strDate}T00:00`).toLocaleDateString("es-EC", { year: "numeric", month: "long", day: "numeric" });
        }
        else {
            return strDate;
        }
    }

    renderFormulario() {
        return (
            <form
                name="formularioCIBB"
                //enctype="multipart/form-data" method="post"
                onSubmit={ this.onSubmit }
            >
                <Loading loading={this.state.isLoading} background="rgba(0,0,0,0.3)" loaderColor="#43A6D2" />

                {!this.state.isDespuesRegInicio &&
                    <div className="alert alert-warning" role="alert">
                        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" />
                    <p className="alert-title"><i className="bi bi-exclamation-triangle-fill"></i><strong> ¡ADVERTENCIA! </strong></p>
                    <p>Este congreso empieza la etapa de registro el día <strong>{this.formatDateString(this.state.fechaInicioInsc)}</strong>.</p>
                    </div>}
                {!this.state.isAntesRegFin &&
                    <div className="alert alert-warning" role="alert">
                        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" />
                    <p className="alert-title"><i className="bi bi-exclamation-triangle-fill"></i><strong> ¡ADVERTENCIA! </strong></p>
                        <p>Este congreso ha culminado la etapa de registro el día <strong>{this.formatDateString(this.state.fechaFinInsc)}</strong>, por lo que no se aceptarán más participantes.</p>
                    </div>}

                <div>
                    <label className="form-label label-style">Elija su documento de identificación / Select your identification document <span className="required-span">*</span></label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoIdentificacion"
                        id="CedulaRadio"
                        onChange={this.handleChange}
                        value="C"
                        //defaultChecked
                    />
                    <label className="form-check-label" htmlFor="CedulaRadio">Cédula (Ecuador)</label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoIdentificacion"
                        id="PasaporteRadio"
                        onChange={this.handleChange}
                        value="P"
                    />
                    <label className="form-check-label" htmlFor="PasaporteRadio">Pasaporte/Passport - Documento Nacional de Identidad/National Identity Document/DNI (Extranjero/Foreign National)</label>
                </div>
                <br />

                <div>
                    <label htmlFor="paisesSelect" className="form-label label-style">País / Country <span className="required-span">*</span></label>
                    <div>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="paisId"
                            value={this.state.datosFormulario.paisId}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            id="paisesSelect"
                            //disabled={this.state.datosFormulario.tipoIdentificacion === "C"}
                        >
                            <option>País / Country *</option>
                            {this.state.datosFormulario.paises.map((pais) => <option key={pais.siIdPais} value={pais.siIdPais}> {pais.strNombre} </option>)}
                        </select>
                    </div>
                </div>
                <br />

                {this.state.datosFormulario.tipoIdentificacion === "C" &&
                    <>
                    <div className="mb-3">
                        <label htmlFor="cedula" className="form-label label-style">Cédula <span className="required-span">*</span></label>
                        <input
                            className="form-control"
                            id="cedula"
                            maxLength={10}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            type="text"
                            name="numeroIdentificacion"
                            value={this.state.datosFormulario.cedula}
                            //pattern="[0-9]{10}"
                            onKeyDown={
                                function (e) {
                                    if ((e.keyCode < 48 || e.keyCode > 57) && //fuera del rango de numeros
                                        (e.keyCode < 37 || e.keyCode > 40) && //fuera del rango de teclas de flecha
                                        (e.keyCode < 96 || e.keyCode > 105) && //fuera del rango de numeros en teclado numerico
                                        e.keyCode !== 8 && //tecla backspace
                                        !e.ctrlKey &&
                                        e.keyCode !== 46 //tecla delete
                                    ) {
                                        e.preventDefault();
                                        //Swal.fire(
                                        //    "¡Caracter no válido!",
                                        //    "Ingrese solo 10 dígitos en el campo cédula",
                                        //    "error"
                                        //)
                                    }
                                }
                            }
                        />
                    </div>
                    </>
                }

                {this.state.datosFormulario.tipoIdentificacion === "P" &&
                    <>
                    <div className="mb-3">
                        <label htmlFor="pasaporte" className="form-label label-style">Pasaporte/Passport - Documento Nacional de Identidad/National Identity Document <span className="required-span">*</span></label>
                        <input
                            className="form-control"
                            id="pasaporte"
                            maxLength={20}
                            onChange={this.handleChange}
                            onBlur={this.handleBlur}
                            type="text"
                            name="numeroIdentificacion"
                            value={this.state.datosFormulario.cedula}
                            onInput={
                                function (e) {
                                    e.target.value = e.target.value.toUpperCase();
                                }
                            }
                            onKeyDown={
                                function (e) {
                                    //keycode 32 es barra espaciadora
                                    if (e.keyCode === 32) {
                                        e.preventDefault();
                                    }
                                }
                            }
                        />
                    </div>
                    </>
                }
                <br />

                <div>
                    <label htmlFor="nombres" className="form-label label-style">Nombres / First Name <span className="required-span">*</span></label>
                    <input
                        className="form-control"
                        id="nombres"
                        maxLength={50}
                        onChange={this.handleChange}
                        type="text"
                        name="nombres"
                        value={this.state.datosFormulario.nombres}
                        onKeyDown={
                            function (e) {
                                //keycode 190 es el punto
                                if (e.keyCode === 190) {
                                    e.preventDefault();
                                }
                            }
                        }
                    />
                </div>
                <br />
                
                <div>
                    <label htmlFor="apellidos" className="form-label label-style">Apellidos / Last Name <span className="required-span">*</span></label>
                    <input
                        className="form-control"
                        id="apellidos"
                        maxLength={50}
                        onChange={this.handleChange}
                        type="text"
                        name="apellidos"
                        value={this.state.datosFormulario.apellidos}
                        onKeyDown={
                            function (e) {
                                //keycode 190 es el punto
                                if (e.keyCode === 190) {
                                    e.preventDefault();
                                }
                            }
                        }
                    />
                </div>
                <br />



                <div>
                    <label htmlFor="ciudadesSelect" className="form-label label-style">Ciudad / City <span className="required-span">*</span></label>
                    <div>
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            name="ciudadId"
                            onChange={this.handleChange}
                            id="ciudadesSelect"
                        >
                            <option>Ciudad / City *</option>
                            {this.state.datosFormulario.ciudades.map((ciudad) => <option key={ciudad.siIdCanton} value={ciudad.siIdCanton}> {ciudad.strNombreCanton} </option>)}
                        </select>
                    </div>
                </div>
                <br />
                

                <div>
                    <label className="form-label label-style">¿Desde que institución te registras? / From which institution do you register? <span className="required-span">*</span></label>
                </div>

                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoInstitucion"
                        id="empresa"
                        onChange={this.handleChange}
                        value="E"
                    />
                    <label className="form-check-label" htmlFor="empresa">Empresa / Company</label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoInstitucion"
                        id="universidad"
                        onChange={this.handleChange}
                        value="U"
                    />
                    <label className="form-check-label" htmlFor="universidad">Universidad / University</label>
                </div>
                <br />

                <div>
                    <label htmlFor="nombreInstitucion" className="form-label label-style">Indique el nombre de la institución / Indicate the name of the institution <span className="required-span">*</span></label>
                    <input
                        className="form-control"
                        id="nombreInstitucion"
                        maxLength={255}
                        onChange={this.handleChange}
                        type="text"
                        name="nombreInstitucion"
                        value={this.state.datosFormulario.nombreInstitucion}
                        onKeyDown={
                            function (e) {
                                //keycode 190 es el punto
                                if (e.keyCode === 190) {
                                    e.preventDefault();
                                }
                            }
                        }
                    />
                </div>
                <br />

                <div>
                    <label className="form-label label-style">Elija su tipo de participación / Participant Type <span className="required-span">*</span></label>
                </div>


                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoParticipante"
                        id="profesional"
                        onChange={this.handleChange}
                        value="P"
                    />
                    <label className="form-check-label" htmlFor="profesional">Profesional / Professional</label>
                </div>
                <div className="form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        name="tipoParticipante"
                        id="estudiante"
                        onChange={ this.handleChange }
                        value="E"
                    />
                    <label className="form-check-label" htmlFor="estudiante">Estudiante / Student</label>
                </div>
                <br />

                
                {this.state.datosFormulario.tipoParticipante === "E" &&
                    <>
                        <div>
                        <label className="form-label label-style">Elejir uno / Choose one <span className="required-span">*</span></label>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="tipoEstudiante"
                                    id="pregrado"
                                    onChange={this.handleChange}
                                    value="B"
                                />
                            <label className="form-check-label" htmlFor="pregrado">Pregrado / Undergraduate</label>
                            </div>

                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="tipoEstudiante"
                                    id="postgrado"
                                    onChange={this.handleChange}
                                    value="A"
                                />
                            <label className="form-check-label" htmlFor="postgrado">Postgrado / Postgraduate</label>
                            </div>
                        </div>
                        <br />
                    </>
                }

                <div>
                    <label htmlFor="email" className="form-label label-style">Correo electrónico / Email <span className="required-span">*</span></label>
                    <input                        
                        className="form-control"
                        id="email"
                        maxLength={40}
                        placeholder="Ingrese correo electrónico / Enter email"
                        onChange={this.handleChange}
                        name="email"
                        type="email"
                        value={this.state.datosFormulario.email}
                    />
                </div>
                <br />
                
                
                {false && <div>
                    <label htmlFor="celular" className="form-label label-style">Número de celular / Phone number <span className="required-span">*</span></label>
                    <input
                        className="form-control"
                        id="celular"
                        maxLength={10}
                        onChange={this.handleChange}
                        type="text"
                        name="celular"
                        value={this.state.datosFormulario.celular}
                        onKeyDown={
                            function (e) {
                                if ((e.keyCode < 48 || e.keyCode > 57) && //fuera del rango de numeros
                                    (e.keyCode < 37 || e.keyCode > 40) && //fuera del rango de teclas de flecha
                                    (e.keyCode < 96 || e.keyCode > 105) && //fuera del rango de numeros en teclado numerico
                                    e.keyCode !== 8 && //tecla backspace
                                    !e.ctrlKey &&
                                    e.keyCode !== 46 //tecla delete
                                ) {
                                    e.preventDefault();
                                    //Swal.fire(
                                    //    "¡Caracter no válido!",
                                    //    "Ingrese solo 10 dígitos en el campo celular",
                                    //    "error"
                                    //)
                                }
                            }
                        }
                    />
                </div>}
                <br />


                <div>
           
                    <label className="form-label label-style">Elija su participación en el {this.state.shortitulo} / Choose your participation in the {this.state.shortitulo} <span className="required-span">*</span></label>

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="tipoParticipacion"
                            id="oral"                           
                            onChange={(e) => { this.handleChange(e); this.handleBlur(e) }}
                            value="O"
                        />
                        <label className="form-check-label" htmlFor="oral">Presentación oral / Oral Presentation</label>
                    </div>

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="tipoParticipacion"
                            id="audiocartel"
                            onChange={(e) => { this.handleChange(e); this.handleBlur(e) }}
                            value="P"
                        />
                        <label className="form-check-label" htmlFor="audiocartel">Presentación de cartel / Poster Presentation</label>
                    </div>

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="tipoParticipacion"
                            id="asistente"
                            onChange={(e) => { this.handleChange(e); this.handleBlur(e) }}
                            value="A"
                        />
                        <label className="form-check-label" htmlFor="asistente">Asistente / Assistant</label>
                    </div>
                    <br />

                    {/*<div>*/}
                    {/*    <p>Descargar la guía para la presentación de resúmenes <a href="http://www.cibb.espol.edu.ec/sites/cibb.espol.edu.ec/files/Gu%C3%ADa%20para%20la%20presentaci%C3%B3n%20de%20res%C3%BAmenes.pdf" target="_blank" rel="noopener noreferrer">aquí</a>.</p>*/}
                    {/*    <p>Download the guide for the presentation of abstracts <a href="http://www.cibb.espol.edu.ec/sites/cibb.espol.edu.ec/files/Gu%C3%ADa%20para%20la%20presentaci%C3%B3n%20de%20res%C3%BAmenes.pdf" target="_blank" rel="noopener noreferrer">here</a>.</p>*/}
                    {/*</div>*/}

                    <div>
                        {(this.state.datosFormulario.tipoParticipacion === "O" || this.state.datosFormulario.tipoParticipacion === "P") &&                            
                            <div>
                            <label htmlFor="presentacion" className="form-label label-style">Cargar presentación - máximo 300 palabras (archivo Word)/ Upload your Presentation - maximum 300 words (Word file)<span className="required-span">*</span></label>
                            {/*<label htmlFor="presentacion" className="form-label label-style">Cargar presentación (archivo Word o carpeta comprimida)/ Upload your Presentation (Word file or Zip folder)<span className="required-span">*</span></label>*/}
                            <input
                            onChange={(e) => {
                                //console.log(e.target.files[0].name);
                                var dto = this.state.datosFormulario;
                                dto.presentacion = e.target.files[0]?.name ?? "";
                                this.setState({ datosFormulario: dto });
                                }
                            }
                            className="form-control"
                            type="file"
                            id="presentacion"
                            accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            /*accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/zip,application/x-zip,application/x-zip-compressed"*/
                            name="presentacion" />
                            </div>                            
                        }
                        {this.state.datosFormulario.tipoParticipacion === "A" &&
                            <>
                                <div>
                                    <label className="form-label label-style">Modalidad de asistencia / Assistance modality <span className="required-span">*</span></label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="tipoAsistencia"
                                        id="PresencialRadio"
                                        onChange={this.handleChange}
                                        value="P"
                                        defaultChecked
                                    />
                                <label className="form-check-label" htmlFor="PresencialRadio">Presencial / In person</label>
                                </div>
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="tipoAsistencia"
                                        id="VirtualRadio"
                                        onChange={this.handleChange}
                                        value="O"
                                    />
                                <label className="form-check-label" htmlFor="VirtualRadio">Online / Virtual</label>
                                </div>
                            </>
                        }

                    </div>
                </div>
                <br />

                <div>
                    <label className="form-label label-style">¿Cómo se enteró del {this.state.shortitulo}? / How did you find out about the {this.state.shortitulo}? <span className="required-span">*</span></label>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="modoInformado"
                            id="redesSociales"
                            onChange={this.handleChange}
                            value="R"
                        />
                        <label className="form-check-label" htmlFor="redesSociales">Redes Sociales / Social Media</label>
                    </div>

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="modoInformado"
                            id="paginaWeb"
                            onChange={this.handleChange}
                            value="P"
                        />
                        <label className="form-check-label" htmlFor="paginaWeb">Página Web / Web Page</label>
                    </div>

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="modoInformado"
                            id="emailRadio"
                            onChange={this.handleChange}
                            value="C"
                        />
                        <label className="form-check-label" htmlFor="emailRadio">Correo Electrónico / Email</label>
                    </div>

                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="modoInformado"
                            id="otros"
                            onChange={this.handleChange}
                            value="O"
                        />
                        <label className="form-check-label" htmlFor="otros">Otros / Others</label>
                    </div>
                    <br />

                    <div>
                        {this.state.datosFormulario.modoInformado === "O" &&
                            <>
                            <textarea
                                className="form-control"
                                id="otroModoInformado"
                                onChange={this.handleChange}
                                type="text"
                                maxLength={255}
                                name="otroModoInformado"
                                placeholder="Indique cuál / Please indicate which *"
                                rows={3}
                                value={this.state.datosFormulario.otroModoInformado}
                            >
                            </textarea>
                            </>
                        }
                    </div>                    
                </div>

                {this.state.datosFormulario.pagado != 2 && this.state.datosFormulario.tipoParticipacion === "A" &&
                    <>
                    <div>
                        <label className="form-label label-style">Elija el método de pago / Select your payment method <span className="required-span">*</span></label>
                    </div>
                    <div><p>Info: <a href="https://www.cibb.espol.edu.ec/content/tarifas" target="_blank">https://www.cibb.espol.edu.ec/content/tarifas</a></p></div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="formaPago"
                            id="transferencia"
                            onChange={this.handleChange}
                            value="B"
                        />
                        <label className="form-check-label" htmlFor="transferencia">Transferencia bancaria / Bank transfer</label>
                    </div>
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="radio"
                            name="formaPago"
                            id="tarjeta"
                            onChange={this.handleChange}
                            value="T"
                            
                        />
                        <label className="form-check-label" htmlFor="tarjeta">Tarjeta de crédito/débito - Credit/Debit card</label>&nbsp;{/*<span className="required-span">**Pronto habilitaremos esta forma de pago.**</span>*/}
                    </div>
                    <br />

                    {this.state.datosFormulario.formaPago === "B" &&
                        <>
                        {
                            //<div>
                            //        <p><b>Datos para la transferencia bancaria</b></p>
                            //        <p><b>A nombre de:</b> Empresa Pública de Servicios ESPOL-TECH E.P.</p>
                            //        <p><b>RUC:</b> 0968592010001</p>
                            //        <p><b>Banco:</b> Banco del Pacífico</p>
                            //        <p><b>Tipo de cuenta:</b> Cuenta corriente</p>
                            //        <p><b>Número de cuenta:</b> 7427786</p>
                            //        <p><b>Mail:</b> cibb@espol.edu.ec</p>
                            //    </div>
                        }

                            <div className="infoTransferencia">
                                {/*<label className="label-style">Datos para la transferencia bancaria</label>*/}

                                {/*<table className="tablaInfoBanco tablaCibb">*/}
                                {/*<tbody>*/}
                                {/*        <tr>*/}
                                {/*        <td colSpan="2" style={{ backgroundColor:"#6faa27", textAlign:"center", fontWeight:"bolder"}}>Datos para la transferencia bancaria</td>*/}
                                {/*        </tr>*/}
                                {/*        <tr>*/}
                                {/*            <td className="infoTitulo">Razón Social:</td>*/}
                                {/*            <td>BIONATURALEZA BIOTECH S.A.S.</td>*/}
                                {/*        </tr>*/}
                                {/*        <tr>*/}
                                {/*            <td className="infoTitulo">RUC:</td>*/}
                                {/*            <td>0993383582001</td>*/}
                                {/*        </tr>*/}
                                {/*        <tr>*/}
                                {/*            <td className="infoTitulo">Entidad Bancaria:</td>*/}
                                {/*            <td>Banco del Pacifico</td>*/}
                                {/*        </tr>*/}
                                {/*        <tr>*/}
                                {/*            <td className="infoTitulo">Tipo de Cuenta:</td>*/}
                                {/*            <td>Cuenta Corriente</td>*/}
                                {/*        </tr>*/}
                                {/*        <tr>*/}
                                {/*            <td className="infoTitulo">Número de Cuenta:</td>*/}
                                {/*            <td>08273766</td>*/}
                                {/*        </tr>*/}
                                {/*        <tr>*/}
                                {/*            <td className="infoTitulo">Email:</td>*/}
                                {/*            <td>cibb@espol.edu.ec</td>*/}
                                {/*        </tr>*/}
                                {/*    </tbody>*/}
                            {/*</table>*/}
                            <label className="label-style">Datos para la transferencia bancaria</label>
                            <div className="tables-container-cibb">
                            <table className="tablaInfoBanco tablaCibb">
                                <tbody>
                                    <tr>
                                        <td className="infoTitulo" style={{ backgroundColor: "#6faa27", fontWeight: "bolder", color: "white" }}>Nombre del banco:</td>
                                        <td style={{ backgroundColor: "#6faa27", textAlign: "center", fontWeight: "bolder", color: "white" }}>Banco del Pacifico</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Código Switf:</td>
                                        <td>PACIECEG</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Dirección del Banco:</td>
                                        <td>P. Icaza 200 y Pedro Carbo</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Nombre del Cliente:</td>
                                        <td>Empresa Pública de Servicios ESPOL-TECH E.P.</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Número de Cuenta:</td>
                                        <td>7427786</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Tipo de Cuenta:</td>
                                        <td>Cuenta Corriente (Rotativa de Ingresos)</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Email:</td>
                                        <td>cibb@espol.edu.ec</td>
                                    </tr>
                                </tbody>
                            </table>
                            
                            <table className="tablaInfoBanco tablaCibb">
                                <tbody>
                                    <tr>
                                        <td className="infoTitulo" style={{ backgroundColor: "#6faa27", fontWeight: "bolder", color: "white" }}>Nombre del banco:</td>
                                        <td style={{ backgroundColor: "#6faa27", textAlign: "center", fontWeight: "bolder", color: "white" }}>Banco de Guayaquil</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Código Switf:</td>
                                        <td>GUAYECEG</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Dirección del Banco:</td>
                                        <td>Pichincha 107 y P. Icaza</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Nombre del Cliente:</td>
                                        <td>Empresa Pública de Servicios ESPOL-TECH E.P.</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Número de Cuenta:</td>
                                        <td>11138640</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Tipo de Cuenta:</td>
                                        <td>Cuenta Corriente (Rotativa de Ingresos)</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Email:</td>
                                        <td>cibb@espol.edu.ec</td>
                                    </tr>
                                </tbody>
                            </table>
                            
                            <table className="tablaInfoBanco tablaCibb">
                                <tbody>
                                    <tr>
                                        <td className="infoTitulo" style={{ backgroundColor: "#6faa27", fontWeight: "bolder", color: "white" }}>Nombre del banco:</td>
                                        <td style={{ backgroundColor: "#6faa27", textAlign: "center", fontWeight: "bolder", color: "white" }}>Banco de Pichincha</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Código Switf:</td>
                                        <td>PICHECEQ</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Dirección del Banco:</td>
                                        <td>Av. Francisco de Orellana y Justino Cornejo, Mezanine</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Nombre del Cliente:</td>
                                        <td>Empresa Pública de Servicios ESPOL-TECH E.P.</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Número de Cuenta:</td>
                                        <td>2100300388</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Tipo de Cuenta:</td>
                                        <td>Cuenta Corriente (Rotativa de Ingresos)</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Email:</td>
                                        <td>cibb@espol.edu.ec</td>
                                    </tr>
                                </tbody>
                            </table>
                            
                            <table className="tablaInfoBanco tablaCibb">
                                <tbody>
                                    <tr>
                                        <td className="infoTitulo" style={{ backgroundColor: "#6faa27", fontWeight: "bolder", color: "white" }}>Nombre del banco:</td>
                                        <td style={{ backgroundColor: "#6faa27", textAlign: "center", fontWeight: "bolder", color: "white" }}>Banco de la Producción – Produbanco</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Código Switf:</td>
                                        <td>PRODECEQ</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Dirección del Banco:</td>
                                        <td>Urbanización Ciudad Colón, Av. Presidente Jaime Roldós Aguilera S/N</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Nombre del Cliente:</td>
                                        <td>Empresa Pública de Servicios ESPOL-TECH E.P.</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Número de Cuenta:</td>
                                        <td>72006000126</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Tipo de Cuenta:</td>
                                        <td>Cuenta Corriente (Rotativa de Ingresos)</td>
                                    </tr>
                                    <tr>
                                        <td className="infoTitulo">Email:</td>
                                        <td>cibb@espol.edu.ec</td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                                {/*<br />*/}
                                {/*<p><b>Mail:</b> <a href="mailto:financierofcnm@espol.edu.ec?subject=Registro a la ESCUELA DE INGENIERÍA QUÍMICA">financierofcnm@espol.edu.ec</a></p>*/}
                                {/*<br />*/}
                            </div>

                            <div>
                                <label htmlFor="comprobantePago" className="form-label label-style">Adjuntar comprobante de pago<span className="required-span">*</span></label>
                                <input
                                    className="form-control"
                                    type="file"
                                    id="comprobantePago"
                                    name="comprobantePago"
                                    //accept=".pdf"
                                    //accept="image/jpeg,image/png,application/pdf"
                                    accept=".jpg, .jpeg, .png, .pdf"
                                />
                            </div>
                            <br />
                        </>
                    }
                    
                        
                    </>                    
                }
                <div>
                    <input
                        type="checkbox"
                        className="mr-2"
                        key={"aceptaAvisoTraDatos"}
                        id={`aceptaAvisoTraDatos`}
                        required
                        name={"aceptaAvisoTraDatos"}
                        checked={this.state.datosFormulario.aceptaAvisoTraDatos}
                        onInvalid={(e) => e.target.setCustomValidity("Aceptar el Aviso Legal de Tratamiento de Datos.")}
                        onChange={(e) => { this.handleChange(e); e.target.setCustomValidity("") }}
                        title="Aceptar el Aviso Legal de Tratamiento de Datos"
                    />
                    <label htmlFor="aceptaAvisoTraDatos" className="">Acepto el&nbsp;</label><a style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => this.showTermsTratamiento()}>Aviso Legal de Tratamiento de Datos</a> <span className="required-span">*</span>
                </div>

                <div>
                    {/*<input type="submit" value="Registrar" />*/}
                    <ReCAPTCHA
                        sitekey={process.env.REACT_APP_SITE_KEY}
                        onChange={this.handleRecaptchaChange}
                    />
                    <br />
                    <button disabled={ /*false &&*/ this.state.isRegistrado || !(this.state.isDespuesRegInicio && this.state.isAntesRegFin)} type="submit" className="btn btn-secondary" style={{ marginBottom: "16px" }}>Registrar</button>
                </div>
                {this.state.isRegistrado && <div className="alert alert-danger" role="alert">
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css" />
                    <p className="alert-title"><i className="bi bi-x-circle"></i> ADVERTENCIA! </p>
                    <p>Formulario de congreso ya enviado.</p>
                </div>}
            </form>
        )
    }
}

export default Formulario;